import { render, staticRenderFns } from "./BusCheckinDataTable.vue?vue&type=template&id=78541d5a&scoped=true&"
import script from "./BusCheckinDataTable.vue?vue&type=script&lang=js&"
export * from "./BusCheckinDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BusCheckinDataTable.vue?vue&type=style&index=0&id=78541d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78541d5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDataTable,VIcon})
